import { render } from "preact";
import { App } from "./app";
import { bindConnectivity } from "./store/store";
import { restoreSession } from "./auth/session";
import { bindTheme } from "./render/theme";
import "./styles.css";

render(<App />, document.getElementById("app")!);

// Slice 3: online/offline を監視し、復帰時に保留編集を自動再送する。
bindConnectivity();

// ③ ダークモード: システムのカラースキーム変化を監視（auto 時に追従）。
bindTheme();

// Slice 5 (PF34): 保存済みトークンがあれば /me で検証・ユーザー情報を復元。
void restoreSession();

// PWA: Service Worker 登録（アプリシェルをオフライン起動可能に）。
// データ API（別オリジン Worker）はキャッシュ介在しない＝SW は自己完結シェルのみ扱う。
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* 登録失敗は致命的でない（オフライン起動が使えないだけ） */
    });
  });
}
